export default "__VITE_ASSET__BMlO$8Wi__"